import { Dropdown } from "react-bootstrap";
import { generatePath, Link, useNavigate } from "react-router-dom";
import { CLIENT_REPORT_TYPES } from "config/constants";
import StepsProgress from "components/shared/FormComponents/StepsProgress";
import { useMemo, useState } from "react";
import { useCreateBlankReportMutation } from "store/services/clients/reports-v2/schoolReports";
import LoadingOverlay from "../LoadingOverlay";
import { useSelector } from "react-redux";

const ClientsReportMenu = ({ client, index, v2 = false, isButton = false, disabled }) => {
  const [dropdownIndex, setDropdownIndex] = useState(null);

  const navigate = useNavigate();

  const clientType = client?.client_detail?.client_type;

  const [blankReport, { isLoading: blankReportLoading }] = useCreateBlankReportMutation()

  const sortedReports = useMemo(() => {
    return Object.entries(CLIENT_REPORT_TYPES)
      .sort(([, a], [, b]) => (a.sortOrder ?? Infinity) - (b.sortOrder ?? Infinity))
      .filter(([, report]) => report?.clients?.includes(clientType));
  }, [clientType]);

  const handleNavigate = async (assessmentId, report, assessmentDetails) => {
    if (!v2) {
      const savedForLater = assessmentDetails?.save_for_later === "yes";
      let path = report.path;

      if (savedForLater) {
        path = report.editPath || report.path
      }

      navigate(generatePath(path.replace("/:reportId", ""), {
        assessmentId: assessmentId,
        clientId: client.id,
        clientType
      }))
    }
    else {
      let path = report.path;
      try {
        const result = await blankReport({ assessmentId, clientId: client.id, clientType }).unwrap()
        navigate(generatePath(path, {
          assessmentId,
          clientId: client.id,
          clientType,
          reportId: result?.data?.report_id
        }))
        console.log('result fo the black', clientType, generatePath(path, {
          assessmentId,
          clientId: client.id,
          clientType,
          reportId: result?.data?.report_id
        }))
      } catch (error) {
        console.log('error generating report: ', error)
      }
    }
  }
  const profile = useSelector((state) => state?.auth?.user)
  return (
    <div className="ActnBtn d-flex align-items-center  gap-10">
      {blankReportLoading && <LoadingOverlay />}
      <Dropdown
        onClick={(e) => e.stopPropagation()}
        show={index == dropdownIndex}
        onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
      >
        <Dropdown.Toggle
          variant="transparent"
          className="p-0 border-0 text-dark w-100"
          id="dropdown-basic"
          disabled={disabled}
        >
          {
            isButton ?
              <button className="discharge-screen">
                New Report
                <span className="ms-2">
                  <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.939684 1.3674L6.16086 6.18695C6.35239 6.36374 6.64761 6.36375 6.83914 6.18695L12.0603 1.3674C12.3948 1.05868 12.1763 0.500001 11.7212 0.500001L1.27883 0.5C0.82367 0.5 0.605235 1.05868 0.939684 1.3674Z" fill="white" />
                  </svg>
                </span>
              </button> :
              <span className="icn ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="13"
                  viewBox="0 0 28 13"
                  fill="none"
                >
                  <rect width="28" height="13" rx="6.5" fill="" />
                  <path
                    d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
                    fill="#315D99"
                  />
                  <path
                    d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
                    fill="#315D99"
                  />
                  <path
                    d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
                    fill="#315D99"
                  />
                </svg>
              </span>
          }
        </Dropdown.Toggle>

        <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
          <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
            <h5 className="proxima mb-2" style={{ borderBottom: "0.5px solid #000", padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Start a New Report...</h5>
            {sortedReports.map(([id, report], i) => {
              console.log('report Id', id)
              let isDisabled = Array.isArray(report?.disabled) ? report?.disabled?.includes(clientType) : report?.disabled;
              if(profile?.role_type == "apprentice"){
                const allowedReportsForApprentice = ["10","13","14"];
                if(!allowedReportsForApprentice.includes(id)){
                  isDisabled = true;
                }
                if(clientType == 'home_education'){
                  isDisabled = true;
                }
              }
              const assessmentDetails = client?.caseloadAssessments?.find(
                (assessment) =>
                  assessment.assesment_type == id
              );

              if (report?.clients?.includes(clientType)) return (
                <li className=""
                  style={{ cursor: "pointer" }}
                  key={i}
                  onClick={(e) => !isDisabled ? handleNavigate(id, report, assessmentDetails) : e.preventDefault()}
                >
                  <Link
                    style={{ color: "#93278F", fontSize: "14px", fontWeight: 500, textAlign: "left" }}
                    className={`border-0 proxima dropdown-reports btn py-2 pe-2 ps-3 ${isDisabled ? "disabled text-muted" : ""}`}
                    variant="transparent"
                  >
                    {report.name}
                  </Link>
                  {/* <StepsProgress
                        steps={["pending", "processing", "submitted", "complete"]}
                        currentStep={assessmentDetails?.status || "pending"}
                      /> */}

                </li>
              );
            })}
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default ClientsReportMenu;